// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {ActivityState, ConnectivityState, Media, MediaType, PlayerMapping} from "@models";
import {SimUtilityExtendedService} from "@services";

@Component({
	selector: "sim-media-card-image",
	templateUrl: "./media-card-image.component.html",
	styleUrls: ["./media-card-image.component.scss"],
	standalone: false,
})
export class MediaCardImageComponent {
	MediaType = MediaType;
	ConnectivityState = ConnectivityState;
	ActivityState = ActivityState;

	@Input() media: Media;
	@Input() mediaPlayer: PlayerMapping;
	toggleMedia = output<{
		player: PlayerMapping;
		media: Media;
	}>();

	constructor(public simUtilityService: SimUtilityExtendedService) {}

	mediaClicked() {
		if (this.mediaPlayer?.webSocket?.activityState !== ActivityState.Inactive) {
			this.toggleMedia.emit({
				player: this.mediaPlayer,
				media: this.media,
			});
		}
	}
}
